<template>
  <div id="express-two-number">
    <div class="row">
        <div class="col">
          <button class="btn mb-2 mx-1 btn-info" v-for="(number, index) in inputNumbers" @click="toggleRemove(index)">{{number}}</button>
        </div>
      <div class="col-auto">
        <button type="button" class="btn btn-danger btn-sm" @click="clearNumbers"><i class="fas fa-trash-alt mr-1"></i>ยกเลิก</button><br />
        <button type="button" class="btn btn-primary btn-sm mt-1" @click="uniqueNumbers"><i class="fas fa-ban mr-1"></i>ลบเลขซ้ำ</button>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mt-1">
        <button type="button" class="btn shadow-sm btn-warning btn-sm" @click="toggleDoubleNumber"><i class="fas fa-plus"></i> เลขเบิ้ล</button>
      </div>
    </div>

    <div ref="twoNumber" class="form-group row mt-1 mb-3">
      <div class="col pr-1">
        <label for="" class="small mb-1">ใส่เลข</label>
        <b-form-input
          type="text"
          class="form-control express"
          name="inputNumber"
          v-on:keydown="keypress"
          maxlength="2"
          v-model="inputNumber"
          inputmode="numeric"
          pattern="[0-9]*"
        />
      </div>
      <div class="col-auto px-1 align-self-end">
        <button class="btn btn-warning" @click="toggleSpin">กลับเลข</button>
      </div>
      <div class="col px-1 text-center">
        <label for="" class="small mb-1">บน</label>
        <b-form-input
          type="text"
          class="text-center form-control express"
          name="amountTop"
          v-on:keydown="keypress"
          v-model="amountTop"
          :disabled="!isOpenTwoTop"
          :placeholder="!isOpenTwoTop?'ไม่เปิดแทง':''"
          :number="true"
          inputmode="numeric"
          pattern="[0-9]*"
        />
      </div>
      <div class="col px-1 text-center">
        <label for="" class="small mb-1">ล่าง</label>
        <b-form-input
          type="text"
          class="text-center form-control express"
          name="amountBot"
          v-on:keydown="keypress"
          v-model="amountBot"
          :disabled="!isOpenTwoBot"
          :placeholder="!isOpenTwoBot?'ไม่เปิดแทง':''"
          :number="true"
          inputmode="numeric"
          pattern="[0-9]*"
        />
      </div>
      <div class="col-auto pl-1 mt-2 text-center align-self-end">
        <button type="button" class="btn btn-info express" @click="addBill"><i class="fas fa-plus mt-1"></i> เพิ่มบิล</button>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from 'sweetalert2'
import _ from 'lodash'

export default {
  name: 'TwoNumber',
  data() {
    return {
      elements: null,
      inputNumber: '',
      amountTop: null,
      amountBot: null,
      inputNumbers: []
    }
  },
  computed: {
    rate() {
      return this.$store.state.round.rate
    },
    isOpenThreeTop() {
      return this.rate?.openBets.threeNumberTop.isAvailable || false
    },
    isOpenThreeTod() {
      return this.rate?.openBets.threeNumberTode.isAvailable || false
    },
    isOpenTwoTop() {
      return this.rate?.openBets.twoNumberTop.isAvailable || false
    },
    isOpenTwoBot() {
      return this.rate?.openBets.twoNumberBottom.isAvailable || false
    },
    isOpenRunTop() {
      return this.rate?.openBets.runTop.isAvailable || false
    },
    isOpenRunBot() {
      return this.rate?.openBets.runBottom.isAvailable || false
    }
  },
  watch: {
    inputNumber(n, o) {
      if(n.length === 2) {
        this.addNumber(n)
        this.inputNumber = ''
      }
    },
    inputNumbers(n, o) {
      this.$emit('inputNumbers', n)
    }
  },
  methods: {
    addNumber(number) {
      // if(!this.inputNumbers.includes(number))
      this.inputNumbers.push(number)
    },
    toggleSpin() {
      this.inputNumbers.forEach((number)=>{
        const n = number.split('')
        _.uniq([
          `${n[0]}${n[1]}`,
          `${n[1]}${n[0]}`
        ])
        .forEach((n)=>{
          if(n!==number) {
            this.addNumber(n)
          }
        })
      })
      this.focusInputAmount()
    },
    toggleDoubleNumber() {
      for(let i=0; i<=9; i++){
        this.addNumber(`${i}${i}`)
      }
      this.focusInputAmount()
    },
    toggleRemove(index) {
      this.inputNumbers.splice(index, 1)
    },
    addBill() {
      console.log('add bill')

      /**
       * ยังไม่กรอกเลข
       */
      if(this.inputNumbers.length === 0)
        return Swal.fire({
          text: 'กรุณาใส่เลขที่จะเล่น',
          icon: 'warning',
          confirmButtonText: 'OK'
        })
        .then(()=>{
          this.focusInputNumber()
        })

      /**
       * ไม่ใส่ราคา
       */
      if(!this.amountTop && !this.amountBot)
        return Swal.fire({
          text: 'กรุณาใส่ยอดเงินที่จะเล่น',
          icon: 'warning',
          confirmButtonText: 'OK'
        })
        .then(()=>{
          this.focusInputAmount()
        })

      const maxTop = this.rate.betLimit.twoNumberTop.max
      const maxBot = this.rate.betLimit.twoNumberBottom.max

      const amountTop = (this.amountTop || 0) //> maxTop ? maxTop : (this.amountTop || 0)
      const amountBot = (this.amountBot || 0) //> maxBot ? maxBot : (this.amountBot || 0)
      const billAmount = this.inputNumbers.reduce((total, number)=>{
        total += (amountTop + amountBot)
        return total
      }, 0)

      const bill = {
        type: 'twoNumber',
        text: {
          title: '2 ตัว',
          description: 'บน x ล่าง',
          amount: `${amountTop} x ${amountBot}`
        },
        numbers: this.inputNumbers,
        amountTop: amountTop,
        amountBot: amountBot,
        billAmount: billAmount
      }
      this.$emit('addBill', bill)

      /**
       * reset ค่า
       */
      this.inputNumbers = []
      this.inputNumber = ''
      this.amountTop = ''
      this.amountBot = ''
      this.focusInputNumber()
    },
    clearNumbers() {
      this.inputNumbers = []
    },
    uniqueNumbers() {
      this.inputNumbers = _.uniq(this.inputNumbers)
    },
    keypress(event) {
      console.log(event.key)
      const focusable = this.elements
      const els = []
      focusable.forEach((el)=>{
        if(!el.disabled)
          els.push(el)
      })

      const cIndex = els.findIndex(el=>el===event.target)
      // ไปข้างหน้า
      if(['Enter', 'ArrowRight', 'ArrowDown', 'Tab'].includes(event.key)) {
        const nIndex = cIndex + 1
        if(nIndex < els.length) {
          els[nIndex].focus()
          event.preventDefault()
        }
      }else // ย้อนกลับ
      if(['ArrowLeft', 'ArrowUp'].includes(event.key)) {
        const nIndex = cIndex - 1
        if(nIndex >= 0) {
          els[nIndex].focus()
          event.preventDefault()
        }
      }else
      if(event.code === 'Space') {
        this.toggleSpin()
        event.preventDefault()
      }else
      if(!['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace'].includes(event.key)) {
        event.preventDefault()
      }
    },
    focusInputNumber() {
      setTimeout(()=>{
        this.elements[0].focus()
      }, 500)
    },
    focusInputAmount() {
      setTimeout(()=>{
        this.elements[1].focus()
      }, 500)
    }
  },
  mounted() {
    this.elements = this.$refs.twoNumber.getElementsByClassName('express')
    this.focusInputNumber()
  }
}
</script>
